import 'regenerator-runtime/runtime'
import {createStore, applyMiddleware, compose, Middleware} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducers from './reducers';
import rootSaga from './sagas';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
import websocketMiddleware from './middlewares/websocketMiddleware';


const composeEnhancers = process.env.NODE_ENV === 'production' ? compose : (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, websocketMiddleware];

if (process.env.NODE_ENV === 'development') {
    middlewares.push(immutableStateInvariantMiddleware());
}

let storeInstance = null;

const configureStore = () => {
    storeInstance = {
        ...createStore(
            rootReducers,
            composeEnhancers( applyMiddleware(...middlewares) )
        ),
        runSaga : sagaMiddleware.run(rootSaga)
    };
    return storeInstance;
};

/**
 * Accessor for the configured store, for the few call sites that need to
 * dispatch from outside the React tree — react-router loaders in particular,
 * which run before any <Provider> is in scope.
 *
 * Returns null until `configureStore()` has run, so callers must null-check.
 *
 * @returns {object|null} the store, or null if not yet configured.
 */
export const getStore = () => storeInstance;

export default configureStore;